import React from 'react'
import {Route, useParams} from 'react-router-dom'
import MainPageLayout from '../../layout/MainPageLayout'
import BatchPageLayout from '../../layout/BatchPageLayout'

const BatchPageRoute = ({path, exact, component: Component, ...rest}: {
	path: string,
	exact?: boolean,
	component?: any,
	rest?: any
}) =>
{
	const params = useParams()
	const matchProps = { match: { params } }
	return (
		<BatchPageLayout>
			<Component {...matchProps} />
		</BatchPageLayout>
	)
}

export default BatchPageRoute
